import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface CreateDemoAccountResponse {
  data: {
    results?: Array<{
      index: number;
      success: boolean;
      errorMessage?: string;
      user?: {
        uid: string;
        email: string;
        firstname: string;
        lastname: string;
        password: string;
      };
      subscriptions?: {
        id: string;
        name: string;
      }[];
    }>;
    accounts?: Array<{
      index: number;
      user: {
        uid: string;
        email: string;
        firstname: string;
        lastname: string;
        password: string;
      };
      subscriptions: {
        id: string;
        name: string;
      }[];
    }>;
  };
  statusCode: number;
  statusReponse: string;
  success: boolean;
}

async function createDemoAccount(
  payload: Record<string, unknown>,
  auth: Authentication | null,
): Promise<CreateDemoAccountResponse> {
  try {
    if (!auth) throw new CreateDemoAccountFailure('Vous devez être connecté pour effectuer cette action.', 'unauthorized');

    const response = await HttpClient.post(
      `/backoffice/demoaccount/create`,
      payload,
      auth.token
    );

    return response;
  } catch (e) {
    if (e instanceof CreateDemoAccountFailure) throw e;
    // HttpClient throws plain Error; preserve message so the UI can show it
    const errMessage =
      e instanceof Error
        ? e.message
        : typeof e === 'string'
          ? e
          : 'Une erreur inattendue s’est produite.';
    throw new CreateDemoAccountFailure(
      errMessage.trim() || 'Erreur réseau ou serveur. Réessayez plus tard.',
      'request-failed',
    );
  }
}

export class CreateDemoAccountFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default createDemoAccount;
